import { render, staticRenderFns } from "./ListLevelMailboxes.vue?vue&type=template&id=2d0e4df0&scoped=true&"
import script from "./ListLevelMailboxes.vue?vue&type=script&lang=js&"
export * from "./ListLevelMailboxes.vue?vue&type=script&lang=js&"
import style0 from "./ListLevelMailboxes.vue?vue&type=style&index=0&id=2d0e4df0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0e4df0",
  null
  
)

export default component.exports